import { LocalizedStrict } from "../../../localization/components/AppLocalized"
import { NavMenuItem } from "../../../../shared/layouts/components/NavMenuItem"
import { faHome, faBuilding, faSliders, faFileImport, faGear } from "@fortawesome/pro-light-svg-icons"
import {
    COMPANY_ADMIN_ROUTE,
    COMPANY_ADMIN_ORGANIZATION_ROUTE,
    COMPANY_ADMIN_ORGANIZATION_USERS_ROUTE,
    COMPANY_ADMIN_ACCOUNT_ADMINS_ROUTE,
    COMPANY_ADMIN_ACCOUNTING_BILL_RECEIVERS_ROUTE,
    COMPANY_ADMIN_ORGANIZATION_LOCATIONS_ROUTE,
    COMPANY_ADMIN_ORGANIZATION_DEPARTMENTS_ROUTE,
    COMPANY_ADMIN_ACCOUNT_GDPR_ROUTE,
    COMPANY_ADMIN_ACCOUNT_ROUTE,
    COMPANY_ADMIN_DATA_IMPORT_ROUTE,
    COMPANY_ADMIN_DATA_IMPORT_USERS_ROUTE,
    COMPANY_ADMIN_DATA_IMPORT_ID_CARDS_ROUTE,
    COMPANY_ADMIN_DATA_IMPORT_ACCOUNT_NUMBERS_ROUTE,
    COMPANY_ADMIN_DATA_IMPORT_BILL_RECEIVERS_ROUTE,
    COMPANY_ADMIN_ORGANIZATION_USER_GROUPS_ROUTE,
    COMPANY_ADMIN_SETTINGS_ROUTE,
    COMPANY_ADMIN_SETTINGS_CUSTOM_JOBS_ROUTE,
} from "../../../../constants/routes"
import { NavMenuItemGroupWrapper, NavMenuSubItem } from "../../../../shared/layouts/components/NavMenuItemGroup"
import { MatchEnvironment } from "../../../environment/components/MatchEnvironment"
import { EnvironmentType } from "../../../environment/envTypes"

export function CompanyAdminNavItems() {
    return (
        <>
            <LocalizedStrict id="company-nav-item-home">
                <NavMenuItem icon={faHome} dest={COMPANY_ADMIN_ROUTE}>
                    Home
                </NavMenuItem>
            </LocalizedStrict>
            <MatchEnvironment environments={[EnvironmentType.Local, EnvironmentType.Test, EnvironmentType.QA]}>
                <LocalizedStrict id="company-nav-item-organization" attrs={{ title: true }}>
                    <NavMenuItemGroupWrapper
                        icon={faBuilding}
                        dest={COMPANY_ADMIN_ORGANIZATION_ROUTE}
                        title="Organization"
                    >
                        <LocalizedStrict id="company-nav-item-users">
                            <NavMenuSubItem route={COMPANY_ADMIN_ORGANIZATION_USERS_ROUTE}>Users</NavMenuSubItem>
                        </LocalizedStrict>
                        <LocalizedStrict id="company-nav-item-bill-receivers">
                            <NavMenuSubItem route={COMPANY_ADMIN_ACCOUNTING_BILL_RECEIVERS_ROUTE}>
                                Bill receivers
                            </NavMenuSubItem>
                        </LocalizedStrict>
                        <LocalizedStrict id="company-nav-item-user-groups">
                            <NavMenuSubItem route={COMPANY_ADMIN_ORGANIZATION_USER_GROUPS_ROUTE}>
                                User groups
                            </NavMenuSubItem>
                        </LocalizedStrict>
                        <LocalizedStrict id="company-nav-item-departments">
                            <NavMenuSubItem route={COMPANY_ADMIN_ORGANIZATION_DEPARTMENTS_ROUTE}>
                                Departments
                            </NavMenuSubItem>
                        </LocalizedStrict>
                        <LocalizedStrict id="company-nav-item-locations">
                            <NavMenuSubItem route={COMPANY_ADMIN_ORGANIZATION_LOCATIONS_ROUTE}>
                                Locations
                            </NavMenuSubItem>
                        </LocalizedStrict>
                    </NavMenuItemGroupWrapper>
                </LocalizedStrict>
            </MatchEnvironment>
            <LocalizedStrict id="company-nav-item-data-import-title" attrs={{ title: true }}>
                <NavMenuItemGroupWrapper icon={faFileImport} dest={COMPANY_ADMIN_DATA_IMPORT_ROUTE} title="Data import">
                    <LocalizedStrict id="company-nav-item-import-users">
                        <NavMenuSubItem route={COMPANY_ADMIN_DATA_IMPORT_USERS_ROUTE}>Users</NavMenuSubItem>
                    </LocalizedStrict>
                    <LocalizedStrict id="company-nav-item-id-cards">
                        <NavMenuSubItem route={COMPANY_ADMIN_DATA_IMPORT_ID_CARDS_ROUTE}>ID cards</NavMenuSubItem>
                    </LocalizedStrict>
                    <LocalizedStrict id="company-nav-item-account-numbers">
                        <NavMenuSubItem route={COMPANY_ADMIN_DATA_IMPORT_ACCOUNT_NUMBERS_ROUTE}>
                            Account numbers
                        </NavMenuSubItem>
                    </LocalizedStrict>
                    <LocalizedStrict id="company-nav-item-import-bill-receivers">
                        <NavMenuSubItem route={COMPANY_ADMIN_DATA_IMPORT_BILL_RECEIVERS_ROUTE}>
                            Bill receivers
                        </NavMenuSubItem>
                    </LocalizedStrict>
                </NavMenuItemGroupWrapper>
            </LocalizedStrict>
            <LocalizedStrict id="company-nav-item-account-title" attrs={{ title: true }}>
                <NavMenuItemGroupWrapper icon={faSliders} dest={COMPANY_ADMIN_ACCOUNT_ROUTE} title="Account">
                    <LocalizedStrict id="company-nav-item-gdpr">
                        <NavMenuSubItem route={COMPANY_ADMIN_ACCOUNT_GDPR_ROUTE}>GDPR</NavMenuSubItem>
                    </LocalizedStrict>
                    <LocalizedStrict id="company-nav-item-admins">
                        <NavMenuSubItem route={COMPANY_ADMIN_ACCOUNT_ADMINS_ROUTE}>Administrators</NavMenuSubItem>
                    </LocalizedStrict>
                </NavMenuItemGroupWrapper>
            </LocalizedStrict>
            <LocalizedStrict id="company-nav-item-settings-title" attrs={{ title: true }}>
                <NavMenuItemGroupWrapper icon={faGear} dest={COMPANY_ADMIN_SETTINGS_ROUTE} title="Settings">
                    <LocalizedStrict id="company-nav-item-custom-jobs">
                        <NavMenuSubItem route={COMPANY_ADMIN_SETTINGS_CUSTOM_JOBS_ROUTE}>Custom jobs</NavMenuSubItem>
                    </LocalizedStrict>
                </NavMenuItemGroupWrapper>
            </LocalizedStrict>
        </>
    )
}
